import { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { useAuthStore } from "@/features/auth";
import { Can } from "@/hooks/useCan/Can";
import { useTran } from "@/hooks";
import { PageHeader } from "@/components/common";
import TargetSettingsHeaderActions from "../components/targetSettings/TargetSettingsHeaderActions";
import TargetSettingsFiltersSection from "../components/targetSettings/TargetSettingsFilterSection";
import TargetSettingsTableSection from "../components/targetSettings/TargetSettingsTableSection";
import TargetSettingsDeleteDialog from "../components/targetSettings/TargetSettingsDeleteDialog";
import { useCarbonTargetsStore } from "../hooks";

const CarbonTargetSettingsPage = observer(() => {
  const { t } = useTran();
  const { user } = useAuthStore();
  const permissions = user?.permissions || [];
  const { filters, page, pageSize, getCarbonTargetsList } =
    useCarbonTargetsStore();

  useEffect(() => {
    getCarbonTargetsList();
  }, [filters?.targetYear, page, pageSize]);

  return (
    <div className="space-y-6">
      <PageHeader
        title={t("Target Settings")}
        description={t(
          "Manage disclosure-level target settings with organization scope.",
        )}
        actions={
          <Can
            resource="target_setting"
            action="create"
            // enabled={!isUserLevel}
            userPermissions={permissions}
          >
            <TargetSettingsHeaderActions />
          </Can>
        }
      />
      <TargetSettingsFiltersSection />
      <TargetSettingsTableSection />
      <TargetSettingsDeleteDialog />
    </div>
  );
});

export default CarbonTargetSettingsPage;
